import React from "react";

const GENRE_META = {
  bookishCircle: {
    label: "Bookish Circle",
    text: "Connect with the heart of The Bookish Circle.",
  },
  literaryFiction: {
    label: "Literary Fiction",
    text: "Explore language-rich stories with emotional depth.",
  },
  christian: {
    label: "Christian",
    text: "Discover faith-centered stories and inspiration.",
  },
  romance: {
    label: "Romance",
    text: "Fall in love with stories that stir the heart.",
  },
  romantasy: {
    label: "Romantasy",
    text: "Discover sweeping romance woven with magic, quests, and enchanted worlds.",
  },
  horror: {
    label: "Horror",
    text: "Dare to face your darkest fears.",
  },
  western: {
    label: "Western",
    text: "Ride into tales of rugged landscapes and frontier justice.",
  },
  historical: {
    label: "Historical",
    text: "Travel through time and unforgettable eras.",
  },
  children: {
    label: "Children's",
    text: "Spark imagination with adventures for young readers.",
  },
  fantasy: {
    label: "Fantasy",
    text: "Step into realms of magic, power, and destiny.",
  },
  scifi: {
    label: "Sci-Fi",
    text: "Explore futures beyond imagination.",
  },
  thriller: {
    label: "Thriller",
    text: "Crave the rush? Dive into suspense and danger.",
  },
  nonfiction: {
    label: "Nonfiction",
    text: "Discover truth, insight, and real-world stories.",
  },
  crime: {
    label: "Crime",
    text: "Follow gripping investigations and criminal intrigue.",
  },
  mystery: {
    label: "Mystery",
    text: "Uncover secrets waiting to be solved.",
  },
};

const GenreHeader = ({ genre, joined, onToggleJoin, disabled = false, genreLabel }) => {
  if (!genre || !GENRE_META[genre]) return null;

  const meta = GENRE_META[genre];

  return (
      <div className="flex flex-col items-end mb-2 mt-0">

        <button
          onClick={onToggleJoin}
          disabled={disabled}
          className={`
            w-24 h-24 flex items-center justify-center text-center
            rounded-full text-xs font-medium leading-tight transition-all duration-200

            ${
              joined
                ? `bg-genres-${genre} text-white`
                : `bg-transparent border-2 border-genreRings-${genre} text-genres-${genre} hover:bg-genres-${genre}/10`
            }
          `}
        >
          <div className="whitespace-pre-line">
            {joined ? "✓ Joined" : `Join the\n${genreLabel || meta.label} Circle`}
          </div>
        </button>
        <p className="text-xs max-w-[12rem] text-right mt-2">Joining also subscribes you to this genre’s monthly newsletter from Lady Liza. You can unsubscribe from genre emails.</p>
      </div>
  );
};

export default GenreHeader;
